import { useEffect, useState } from "react";
import { fetchFinancialStatistics } from "../service";
import { formatMoney } from "../../utils";
import { theme } from "../../theme";

const Statistics = ({selectedFtm, dataFilter}) => {
    const [statistics, setStatistics] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getFinancialStatistics = async () => {
            try {
                const response = await fetchFinancialStatistics(selectedFtm?.value, dataFilter);
                setStatistics(response?.data || {});
            } catch (error) {
                console.error("Error fetching Statistics:", error);
            } finally {
                setLoading(false);
            }
        };

        getFinancialStatistics();
    }, [dataFilter, selectedFtm?.value]);

    if (loading) {
        return <div className="text-center p-4">Loading statistics...</div>;
    }

    const statsList = [
        { label: "Total booking fee", key: "total_booking_fee", icon: "event_available" },
        { label: "Total call out fee", key: "total_call_out_fee", icon: "call" },
        { label: "Total materials fee", key: "total_materials_fee", icon: "inventory_2" },
        { label: "Total materials commission", key: "total_materials_commission", icon: "inventory" },
        { label: "Total platform charges", key: "total_platform_charges", icon: "account_balance" },
        { label: "Total platform charges vat", key: "total_platform_charges_vat", icon: "receipt_long" },
        { label: "Total labour", key: "total_labour", icon: "engineering" },
        { label: "Total labour commission", key: "total_labour_commission", icon: "payments" },
    ];

    return (
        <div className="row">
            {statsList.map((stat, index) => (
                <div className="col-sm-3 mb-4" key={index}>
                    <div className="card">
                        <div className="card-body p-3">
                            <div className="row">
                                <div className="col-4">
                                    <div className={`icon icon-lg icon-shape bg-gradient-${theme.main} shadow text-center border-radius-md`}>
                                        <i className="material-icons opacity-10">{stat.icon}</i>
                                    </div>
                                </div>
                                <div className="col-8 my-auto text-end">
                                    <p className="text-sm text-bold mb-0 opacity-7">{stat.label}</p>
                                    <h4 className="font-weight-bolder mb-0">
                                        {formatMoney(statistics?.[stat.key] ?? 0)}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Statistics;